const rootSelector = '[data-contents-insurance-tooltip-root]';
const toggleSelector = '[data-contents-insurance-tooltip-toggle]';
const panelSelector = '[data-contents-insurance-tooltip-panel]';
const mobileGutter = 16;
const desktopGutter = 24;
const tooltipGap = 12;
const arrowPadding = 32;
const desktopBreakpoint = 768;

let hasInitialized = false;

const updateTooltipPosition = (root) => {
  const toggle = root.querySelector(toggleSelector);
  const panel = root.querySelector(panelSelector);

  if (!toggle || !panel || panel.hidden) {
    return;
  }

  const rootRect = root.getBoundingClientRect();
  const toggleRect = toggle.getBoundingClientRect();
  const horizontalGutter =
    window.innerWidth >= desktopBreakpoint ? desktopGutter : mobileGutter;
  const availableWidth = Math.max(window.innerWidth - horizontalGutter * 2, 0);
  const targetWidth =
    window.innerWidth >= desktopBreakpoint
      ? Math.min(400, availableWidth)
      : availableWidth;

  panel.style.width = `${targetWidth}px`;
  panel.style.maxWidth =
    window.innerWidth >= desktopBreakpoint ? '400px' : 'none';
  panel.style.removeProperty('left');
  panel.style.removeProperty('right');

  const panelRect = panel.getBoundingClientRect();
  const toggleCenter = toggleRect.left + toggleRect.width / 2;
  const maxLeft = Math.max(
    horizontalGutter,
    window.innerWidth - panelRect.width - horizontalGutter
  );
  const panelLeft = Math.min(
    Math.max(toggleCenter - panelRect.width / 2, horizontalGutter),
    maxLeft
  );
  const panelTop =
    toggleRect.top - rootRect.top - panelRect.height - tooltipGap;

  panel.style.left = `${panelLeft - rootRect.left}px`;
  panel.style.top = `${panelTop}px`;

  const arrowLeft = toggleCenter - panelLeft;
  const clampedArrowLeft = Math.min(
    Math.max(arrowLeft, arrowPadding),
    panelRect.width - arrowPadding
  );

  panel.style.setProperty(
    '--contents-insurance-tooltip-arrow-left',
    `${clampedArrowLeft}px`
  );
};

const closeTooltip = (root) => {
  const toggle = root.querySelector(toggleSelector);
  const panel = root.querySelector(panelSelector);

  if (panel) {
    panel.hidden = true;
  }

  if (toggle) {
    toggle.setAttribute('aria-expanded', 'false');
  }
};

const closeAllTooltips = () => {
  document.querySelectorAll(rootSelector).forEach(closeTooltip);
};

const bindContentsInsuranceTooltips = () => {
  if (hasInitialized) {
    return;
  }

  hasInitialized = true;

  document.addEventListener('click', (event) => {
    const toggle = event.target.closest(toggleSelector);

    if (toggle) {
      const root = toggle.closest(rootSelector);
      const panel = root ? root.querySelector(panelSelector) : null;
      const isOpening = Boolean(panel?.hidden);

      closeAllTooltips();

      if (root && panel && isOpening) {
        panel.hidden = false;
        toggle.setAttribute('aria-expanded', 'true');
        requestAnimationFrame(() => {
          updateTooltipPosition(root);
        });
      }

      return;
    }

    if (!event.target.closest(rootSelector)) {
      closeAllTooltips();
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      closeAllTooltips();
    }
  });

  window.addEventListener('resize', () => {
    document.querySelectorAll(rootSelector).forEach(updateTooltipPosition);
  });
};

export const initContentsInsuranceTooltip = () => {
  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      bindContentsInsuranceTooltips,
      {
        once: true,
      }
    );
    return;
  }

  bindContentsInsuranceTooltips();
};
